import React from 'react';
import { Graph } from '../generated/graph';

export type UserContextContent = {
  user?: Graph.User
}

export const UserContext = React.createContext<UserContextContent>({});
